// extracted by mini-css-extract-plugin
module.exports = {"appCustom":"appCustom_appCustom__BFZrm"};